import { get, set } from './common';
var AdminOfferListsSortKey = 'adminOfferLists:sort:typica';
var AdminOrderedOfferListsSortKey = 'adminOrderedOfferList:sort:typica';
var SortKeys = {
    adminOfferLists: AdminOfferListsSortKey,
    adminOrderedOfferLists: AdminOrderedOfferListsSortKey,
};
export var setSort = function (key, sort) {
    var sortKey = SortKeys[key];
    set(sortKey, sort);
};
export var getSort = function (key) {
    var sortKey = SortKeys[key];
    var sort = get(sortKey);
    if (sort)
        return sort;
};
